<template>
  <div
    class="search-panel__results px-s lg:pl-8 lg:pr-0 job-card-content w-full lg:w-auto lg:pt-0 -mt-3px flex-1"
  >
    <div class="items-center filter_sortby mb-5 md:mb-6 lg:mb-0">
      <div class="sort-by-container">
        <div class="flex justify-between items-end">
          <div class="flex items-center">
            <i class="feather icon-briefcase text-18 mr-7px text-onyx"></i>
            <span class="found-jobs">
              <ais-state-results>
                <template #default="{ nbHits, processingTimeMS, status }">
                  <span
                    v-if="status === 'loading' || status === 'stalled'"
                    class="inline-flex text-18 mr-7px text-onyx"
                  >
                    <i class="feather icon-loader animate-spin"></i>
                    <span class="sr-only">Loading...</span>
                  </span>
                  <span
                    v-show="!(status === 'loading' || status === 'stalled')"
                  >
                    {{ formatNumber(nbHits) }}
                  </span>
                  jobs found
                </template>
              </ais-state-results>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-24px">
      <ais-infinite-hits :transform-items="transformItems">
        <template #default="{ items, isLastPage, refineNext }">
          <div
            class="mb-4 cursor-pointer"
            v-for="(item, index) in items"
            :key="item.id"
          >
          <a
              v-if="displayedItems.has(item.id)"
              :href="getJobLink(item)"
              :target="item['link_out_param']['is_linkout'] == true && !item['link_out_param']['is_schedule'] ? '_blank' : '_self'"
              @click="redirectToJob(item, $event)"
            >
            <div class="listing-card border-2 border-solid border-transparent w-full rounded-md bg-white shadow-shadow-color">
              <div class="w-auto xl:w-1023px">
                <div class="flex p-6 rounded-8 w-auto">
                  <div class="flex w-16 h-16">
                    <img
                      :alt="`${item.company.name} Logo`"
                      :src="item.company.thumbnail"
                      :title="`${item.company.name} Logo`"
                      class="flex object-contain w-full h-full rounded-md border border-solid border-chrome-lightest"
                      loading="lazy"
                    />
                  </div>
                  <div class="flex flex-col ml-24px md:ml-8 flex-1">
                    <div class="w-full flex align-center justify-between">
                      <div
                        class="text-18 text-primary-darker font-medium leading-normal m-0 p-0 hover:underline cursor-pointer line-height-normal"
                      >
                        {{ getDisplayText(item, index) }}
                      </div>

                      <span
                        v-if="item['is_featured']"
                        class="hidden md:block h-26px"
                      >
                        <vs-chip
                          class="self-start"
                          color="rgba(124, 195, 102, 0.2)"
                        >
                          <span
                            class="m-0 p-0 text-12 text-onyx font-bold w-auto text-center"
                            >Hiring Now</span
                          >
                        </vs-chip>
                      </span>
                    </div>

                    <div
                      class="p-0 m-0 mt-4px text-14 text-onyx-lightest font-semibold"
                    >
                      {{ item.company.name }}
                    </div>

                    <div
                      class="text-onyx-lightest font-normal mt-14px lg:mt-8px w-full flex items-center"
                    >
                      <div
                        class="h-22px w-22px flex justify-center items-center"
                        v-if="displayPerksTypeAs === 'image'"
                      >
                        <vs-icon
                          class="text-lg"
                          :class="params['categories']['icon']['bold'] ?? ''"
                          :icon="params['categories']['icon']['type'] ?? ''"
                          icon-pack="feather"
                        ></vs-icon>
                      </div>

                      <p class="ml-6px text-14 text-onyx-lightest">
                        {{ formatCategories(item) }}
                      </p>
                    </div>

                    <span
                      v-if="item['is_featured']"
                      class="md:hidden mt-16px h-26px"
                    >
                      <vs-chip
                        class="self-start mb-0"
                        color="rgba(124, 195, 102, 0.2)"
                      >
                        <span class="m-0 p-0 text-12 text-onyx font-bold w-auto"
                          >Hiring Now</span
                        >
                      </vs-chip>
                    </span>

                    <div
                      class="perks-wrapper w-auto mt-16px flex flex-wrap gap-2"
                    >
                      <vs-chip
                        v-for="(perk, index) in item['job_perks']"
                        :key="index"
                        :color="perk['color_10']"
                        class="m-0 self-start rounded-6px md:w-72px min-w-fit"
                        :style="displayPerksTypeAs === 'object' ? { minWidth: 'fit-content' } : {}"
                      >
                        <span
                          class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                        >
                          <object v-if="displayPerksTypeAs === 'object'" :data="perk['icon_url']" width="12" height="12" class="translate-icon-object h-3 inline align-baseline"></object>

                          <img
                            v-if="perk['icon_url'] && displayPerksTypeAs === 'image'"
                            :alt="perk['description']"
                            :src="perk['icon_url']"
                            class="translate-icon-object h-3 inline align-baseline"
                            height="12"
                            width="12"
                            loading="lazy"
                          />
                          {{ perk['description'] }}
                        </span>
                      </vs-chip>
                      <vs-chip
                        v-if="item[params['hiring_event_key']] && item[params['hiring_event_key']].includes('Hiring Events')"
                        class="m-0 self-start rounded-6px w-auto md:w-72px"
                        style="min-width: fit-content !important"
                      >
                        <span
                          class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                        >
                          Hiring Event
                        </span>
                      </vs-chip>
                      <vs-chip
                        v-if="item[params['hiring_event_key']] && item[params['hiring_event_key']].includes('Virtual Events')"
                        class="m-0 self-start rounded-6px w-auto md:w-72px"
                        style="min-width: fit-content !important"
                      >
                        <span
                          class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                        >
                          Virtual Event
                        </span>
                      </vs-chip>
                    </div>
                  </div>
                  <hr
                    v-if="showApplyButton"
                    class="divider hidden md:block md:border-chrome-lightest md:border-solid -my-6 md:ml-8 md:mr-23px"
                  />
                  <div v-if="showApplyButton" class="hidden md:block my-auto">
                    <div>
                      <primary-button
                        class="w-80px lg:w-187px"
                        size="large"
                        title="Apply"
                      >
                        Apply
                      </primary-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
          </div>
          <!--          <div>-->
          <!--            Items Length: {{ items.length }}, Displayed:-->
          <!--            {{ displayedItems.size }}, Hidden:-->
          <!--            {{ hiddenItems.length }}-->
          <!--          </div>-->
          <jobs-pagination
            v-if="!isLastPage || isHiddenItems"
            :load-more="isHiddenItems ? updateItemsList : refineNext"
            :jobs-remaining="jobsRemaining"
          />
          <!--          <ais-state-results>-->
          <!--            <template #default="{ state: { page }, status }">-->
          <!--              Page: {{ page }}-->
          <!--              <jobs-pagination-->
          <!--                v-if="!isLastPage || isHiddenItems"-->
          <!--                :load-more="isHiddenItems ? updateItemsList : refineNext"-->
          <!--                :jobs-remaining="jobsRemaining"-->
          <!--              />-->
          <!--            </template>-->
          <!--          </ais-state-results>-->
        </template>
      </ais-infinite-hits>
      <div v-if="items.length === 0">
        <h2 class="text-21 font-bold leading-1-19 text-onyx mb-4 md:mb-24px">
          There are no jobs matching your search
        </h2>
        <p class="text-base text-onyx mb-8 leading-relaxed w-full lg:w-738px">
          Not sure what to look for? Try expanding your search or check out some
          of our other options.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { connectInfiniteHits } from 'instantsearch.js/es/connectors';
import { createWidgetMixin } from 'vue-instantsearch';

import allEvents from '../mixins/events';

import JobsPagination from './JobsPagination.vue';
import { shuffle } from '../utils';

export default {
  name: 'JobsHits',
  mixins: [allEvents, createWidgetMixin({ connector: connectInfiniteHits })],
  components: { JobsPagination },
  props: {
    jobsPerPage: {
      type: Number,
      required: true,
    },
    showApplyButton: {
      type: Boolean,
      default: false,
    },
    paramProp: {
      default: undefined,
    },
  },
  data() {
    return {
      params: JSON.parse(this.paramProp),
      displayPerksTypeAs: this.paramProp ? JSON.parse(this.paramProp)['perks_display_as'] : '',
      displayedItems: new Set(),
      feedbackIcon:
        location.protocol +
        '//' +
        location.host +
        '/images/custom-icons/megaphone.svg',
      hiddenItems: [],
      items: [],
      nbHits: 0,
      sortedItems: [],
    };
  },
  computed: {
    isHiddenItems() {
      return this.hiddenItems.length !== 0;
    },
    jobsRemaining() {
      if (
        this.hiddenItems.length &&
        this.hiddenItems.length < this.jobsPerPage
      ) {
        return this.hiddenItems.length;
      }

      const jobsRemaining = this.nbHits - this.displayedItems.size;

      return jobsRemaining < this.jobsPerPage
        ? jobsRemaining
        : this.jobsPerPage;
    },
  },
  methods: {
    formatNumber(value) {
      return Number(value).toLocaleString();
    },
    getDisplayText(item, index) {
      return process.env.MIX_MEILISEARCH_HOST &&
        process.env.MIX_APP_ENV === 'local'
        ? `${item.title} (${item.id}), Priority: ${item.priority}`
        : item.title;
    },
    getJobLink(job) {
      if (job['link_out_param']['is_linkout'] == true && !job['link_out_param']['is_schedule']) {
        return job['link_out_param']['fullapp_url'] || job['link_out_param']['linkout_url'] || job['link_out_param']['global_fullapp_url'];
      } else {
        return '/jobs/' + job['id'] + '/' + job['slug'];
      }
    },
    redirectToJob(job, event) {
      if (
        job['link_out_param']['is_linkout'] == true
        && !job['link_out_param']['is_schedule']
      ) {
        event.preventDefault();
        this.trackJobFullAppClick(
          job['id'],
          this.getJobLink(job),
          window.location.protocol + '//' + window.location.host + '/thank-you',
        );
      }
    },
    sortJobs(results) {
      const jobs = [...results];
      shuffle(jobs);
      let priorityJobs = {};
      let allPriority = [];
      // const maxPriority = Math.max(...jobs.map(job => job?.priority)) + 1;

      if (jobs.length > 0) {
        jobs.forEach(function (job) {
          let updatedJobCompanyId = `'${job.company.id}'`;
          allPriority.push(job);
          if (!priorityJobs[updatedJobCompanyId]) {
            priorityJobs[updatedJobCompanyId] = {};
          }
          if (!priorityJobs[updatedJobCompanyId][job.priority]) {
            priorityJobs[updatedJobCompanyId][job.priority] = [];
          }
          priorityJobs[updatedJobCompanyId][job.priority].push(job);
        });

        let finalePriority = allPriority.map(job => job.priority);
        finalePriority.sort((a, b) => (a && b ? a - b : b - a));

        let index = 0;
        finalePriority.forEach(function (priority) {
          Object.keys(priorityJobs).forEach(function (companyId) {
            if (
              priorityJobs[companyId][priority] &&
              Object.entries(priorityJobs[companyId][priority])[0]
            ) {
              const [key, job] = Object.entries(
                priorityJobs[companyId][priority],
              )[0];
              jobs[index] = job;
              delete priorityJobs[companyId][priority][key];
              index++;
            }
          });
        });
      }
      return jobs;
    },
    transformItems(items) {
      if (JSON.stringify(items) !== JSON.stringify(this.items)) {
        this.items = items;
        this.sortedItems = this.sortJobs(items);
        this.updateItemsList();
      }
      return this.sortedItems;
    },
    updateItemsList: function () {
      const items = this.hiddenItems.length
        ? this.hiddenItems
        : this.sortedItems;
      this.hiddenItems = [];

      items.forEach((item, index) => {
        const id = item.id ?? item;
        if (index < this.jobsPerPage) {
          if (!this.displayedItems.has(id)) {
            this.displayedItems.add(id);
          }
        } else {
          this.hiddenItems.push(id);
        }
      });
    },
    formatCategories(item) {
      const categories = item.categories
        ? item.categories
        : item[this.params['categories']['key']] || [];

      return categories
        .filter(cat => cat !== 'Hiring Events' && cat !== 'Virtual Events')
        .join(', ');
    },
  },
  watch: {
    state(newState, oldState) {
      this.nbHits = newState.results.nbHits;
      if (
        oldState &&
        JSON.stringify(oldState.hits) !== JSON.stringify(newState.hits) &&
        newState.results.page === 0
      ) {
        this.displayedItems = new Set();
        this.hiddenItems = [];
        this.updateItemsList();
        window.scrollTo(0, 0);
      } else if (!oldState) {
        this.$root.$emit('initialHitsRequestCompleted');
      }
    },
  },
};
</script>
